var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "collapse-body pb-0" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-create-claim-type-form", {
            attrs: { "record-form": _vm.recordForm },
          }),
          _vm._v(" "),
          _c("csp-create-damage-form", {
            attrs: { "record-form": _vm.recordForm },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-4" },
        [
          _c("csp-create-damage-map-image", {
            attrs: { "damage-form": _vm.recordForm.getSubform("damage") },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("csp-record-create-image-file-upload", {
            attrs: {
              "accepted-mime-types": "image/jpeg, image/png, application/pdf",
              "transform-mime-types": "image/jpeg, image/png",
              "upload-file-category-id": _vm.uploadFileCategory,
              "upload-label": "Unfall Foto",
              "upload-session-id": _vm.uploadSessionId,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }